var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"text-uppercase text-decoration-none",attrs:{"href":_vm.url}},[_vm._v("Forgotten your password?")])])}
var staticRenderFns = []

export { render, staticRenderFns }